<template>
  <div :class="classnames">
    <slot />
  </div>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'modal-area'

  export default {
    name: 'ModalArea',
    mixins: [ bem ],
    props: {
      isOpen: {
        type: Boolean
      }
    },
    data: function () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Modal/ModalArea.vue